export const WHOLE_LIFE_RIDERS = {
	// accidental_death_chronic_illness: "Accidental Death Chronic Illness",
	// waiver_of_premium: "Waiver Of Premium"
	accidental_death_chronic_illness: "",
	waiver_of_premium: ""
};
